import { injectGlobal } from "react-emotion/macro"
import "reset-css"
import "slick-carousel/slick/slick.css"
// import "slick-carousel/slick/slick-theme.css"
import "./button"
import { font, color } from "./variables"
import { typography } from "./typography"

injectGlobal`
  @font-face {
    font-family: 'ernest_and_emily_slantedRg';
    src: url('/fonts/nicky_laatz__-_ernest_and_emily_slanted-webfont.woff2')
        format('woff2'),
      url('/fonts/nicky_laatz__-_ernest_and_emily_slanted-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }

  @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,400i,700');

  body {
    background: ${color.rgb.white[0]};
    font-family: ${font.family.sans};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    &.component-overlay-is-active {
      overflow: auto;
    }


    &, a {
      color: ${color.rgb.gray[1]};
      transition: color 0.5s ease, background 0.5s ease, border 0.5s ease, translate 0.5s ease, opacity 0.5s ease;
    }

    path {
      transition: fill 0.5s ease;
    }

    a {
      text-decoration: none;

      &:hover, &:focus {
        text-decoration: underline;

        path {
          fill: ${color.rgb.purple[1]};
        }
      }
    }

    button a {
      &:hover, &:focus { text-decoration: none; }
    }
  }

  * {
    font-family: ${font.family.sans};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  main {
    p + p { margin-top: 25px; }

    ol, ul {
      padding-left: 20px;
    }

    ul {
      list-style: disc;
    }

    ol {
      list-style: decimal;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {

      + p {
        margin-top: 15px;
      }
    }
  }

  main, footer {
    a {
      color: ${color.rgb.orange[0]};
    }
  }

  strong {
    font-weight: 600;
  }
  
  .text-center {
    text-align: center;
  }

  em { font-style: italic; }

  .flexible-content-component > section {

    &.no-padding { padding-bottom: 0; padding-top: 0; }

    &.no-border { padding-bottom: 0; }
  }
  
  #root main {
    background ${color.rgb.white[0]};
  }

  ${typography};
`



// WEBPACK FOOTER //
// /opt/build/repo/src/styles/index.js